import React, { useContext, useState, useEffect } from "react";
import "./Profile.css";
import White_Btn from "../../../common_components/common_btn/white_btn/White_Btn";
import Verify_Profile_Modal from "../../../common_components/common_modal/verify_profile_modal/Verify_Profile_Modal";
import Successfull_Modal from "../../../common_components/common_modal/successfull_modal/Successfull_Modal";
import Success_Lottie from "../../../animation/success_lottie/Success_Lottie";
import { Context } from "../../../../utils/context";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Profile = () => {
  const [showModal, setShowModal] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [stepCompleted, setStepCompleted] = useState(false);

  const { IMG_URL, userdata } = useContext(Context);

  useEffect(() => {
    if (formSubmitted) {
      toast.success("Profile verification submitted successfully!", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
      });

      // setShowSuccessModal(true);
      setTimeout(() => {
        setFormSubmitted(false);
      }, 5000);
    }
  }, [formSubmitted]);

  const isVerified = userdata?.accept_or_reject === true;
  const isRejected = userdata?.accept_or_reject === false;
  const isPending = userdata?.accept_or_reject === 2;

  return (
    <section className="profile-page">
      <ToastContainer position="bottom-right" theme="dark" />

      <div className="profile-grid">
        {/* Personal Details Card */}
        <div className="profile-card personal-info">
          <div className="card-header">
            <div className="header-left">
              <div className="status-badge verified">
                <span className="badge-icon">✓</span>
                Personal Details
              </div>
            </div>
          </div>

          <div className="card-body mt-3">
            <div className="info-grid">
              <div className="info-row">
                <label className="info-label">Contact Number</label>
                <p className="info-value">
                  +91 {userdata?.contact_no || "Not Set"}
                </p>
              </div>

              <div className="info-row">
                <label className="info-label">Email Address</label>
                <p className="info-value">
                  {userdata?.email || "Not Set"}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Identity Verification Card */}
        <div className={`profile-card verification-card ${isVerified ? "verified" : isRejected ? "rejected" : "pending"}`}>
          <div className="card-header">
            <div className="header-left">
              <div className={`status-badge ${isVerified ? "verified" : isRejected ? "rejected" : "pending"}`}>
                <span className="badge-icon">
                  {isVerified ? "✓" : isRejected ? "✗" : "⌛"}
                </span>
                {isVerified
                  ? "Identity Verified"
                  : isRejected
                  ? "Verification Rejected"
                  : "Verify Your Identity"}
              </div>
            </div>

            {!isVerified && (
              <White_Btn
                btn_name={isRejected ? "Update Profile" : "Complete Verification"}
                onClick={() => setShowModal(true)}
                className="verify-action-btn"
              />
            )}
          </div>

          <div className="card-body">
            <div className="verification-info">
              <p className="user-name">
                {userdata?.first_name} {userdata?.last_name || "User"}
              </p>

              {isRejected && (
                <p className="rejected-warning">
                  Your previous submission was rejected. Please update and resubmit your documents.
                </p>
              )}

              {!isVerified && (
                <p className="verification-hint">
                  Upload a valid government-issued ID to unlock full account features.
                </p>
              )}

              {isVerified && (
                <p className="verified-message">
                  Your identity has been successfully verified. All features are now available.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>

      <Verify_Profile_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        setFormSubmitted={setFormSubmitted}
        setStepCompleted={setStepCompleted}
      />

      {/* <Successfull_Modal
        message="Profile Doc Sent For Verification Successfully"
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        lottie={<Success_Lottie />}
      /> */}
    </section>
  );
};

export default Profile;